import { render, staticRenderFns } from "./ErrorCaducado.vue?vue&type=template&id=c56eaed2&scoped=true"
import script from "./ErrorCaducado.vue?vue&type=script&lang=js"
export * from "./ErrorCaducado.vue?vue&type=script&lang=js"
import style0 from "./ErrorCaducado.vue?vue&type=style&index=0&id=c56eaed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56eaed2",
  null
  
)

export default component.exports